/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

function ExportStoreLot({ parent, edit }) {
  const mod = 'export_store_list';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const view = () => {
    FetchData('OPTIONS', `/${mod}/initlot`, app.token, {
      lang: app.lang,
      id: parent.id,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.list);
      }
    });
  };

  const search = () => {
    setModalOpen(true);
    view();
  };

  const btnEdit = (item) => {
    return (
      <MDButton
        variant='text'
        color='primary'
        size='small'
        onClick={() => {
          setModalOpen(false);
          edit({
            id: parent.id,
            estock_id: item.id,
            stock_id: item.stock_id,
            lot: item.lot,
            is_expire: item.is_expire,
            date_expire: item.date_expire,
          });
        }}
      >
        <Icon>published_with_changes</Icon> เปลี่ยน
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0, minHeight: 300 }}>
              <Table aria-label='datasimple table'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center' width={10}>
                      No.
                    </TableCell>
                    <TableCell align='center'>LOT</TableCell>
                    <TableCell align='center'>วันหมดอายุ</TableCell>
                    <TableCell align='center' width={10}>
                      &nbsp;
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {record.map((row, i) => (
                    <TableRow key={row.id}>
                      <TableCell align='center'>{i + 1}</TableCell>
                      <TableCell align='center'>{row.lot}</TableCell>
                      <TableCell align='center'>
                        {row.is_expire === 'Y' ? Func.dateDisplay(row.date_expire) : 'N/A'}
                      </TableCell>
                      <TableCell align='center'>{btnEdit(row)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth='xs'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle>
          LOT
          <IconButton
            aria-label='close'
            onClick={() => setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>{renderList()}</DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      <MDButton
        variant='text'
        color='info'
        size='small'
        sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}
        onClick={search}
      >
        {parent.lot === '' ? 'เลือก LOT' : parent.lot}
      </MDButton>

      {renderAdd()}
    </div>
  );
}

ExportStoreLot.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    lot: PropTypes.string.isRequired,
  }).isRequired,
  edit: PropTypes.func.isRequired,
};

export default ExportStoreLot;
